angular.module("vgresiduos").controller("OrganizationUnitDocumentEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/documento/${$stateParams.id}`);
		};
	}
]);
